import "./ValueForMoneyIndex.module.css";
import Header from "@/reusable_sections/Header";
import ElevateYourImpact from "./sections/ElevateYourImpact";
import LocalServicesInLaval from "./sections/LocalServicesInLaval";
import Footer from "@/reusable_sections/Footer";
export default function ValueForMoneyIndexPage() {
  return <div>
      <Header />
      <ElevateYourImpact />
      <LocalServicesInLaval />
      <Footer />
    </div>;
}